var map = {
	"./Group1/Adoration.webp": 1328,
	"./Group1/ER1.jpg": 7120,
	"./Group1/ER2.webp": 3534,
	"./Group1/ER3.jpeg": 1778,
	"./Group2/Adoration.webp": 8250,
	"./Group2/ER1.jpg": 899,
	"./Group2/ER2.webp": 4013,
	"./Group2/ER3.jpeg": 969
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8417;